module.exports = __webpack_public_path__ + "static/img/dashboard_logo_right.e18715e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/dashboard_logo_right.svg
// module id = ydnr
// module chunks = 73